//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,

    props: {
        value: Object,
        from: Number,
        to: Number,
        minDate: Number,
        maxDate: Number,
        disabledDates: [Date, Object, Array],
        clearable: Boolean,
        autoOpen: Boolean,
        autoClose: Boolean,
        pageDate: Number,
        maxRangeLength: Number,
    },

    computed: {
        from_() {
            return this.from ?? this.value?.from;
        },
        to_() {
            return this.to ?? this.value?.to;
        },
        model: {
            get() {
                return {
                    start: this.from_ && new Date(this.from_),
                    end: this.to_ && new Date(this.to_),
                };
            },
            set(value) {
                const from = value?.start?.getTime() ?? null;
                const to = value?.end?.getTime() ?? null;

                this.$emit('update:from', from);
                this.$emit('update:to', to);
                this.$emit('input', { from, to });
            },
        },
        formattedModel: {
            get() {
                return !this.model ? null : $.formatDateRange(this.from_, this.to_);
            },
            set(value) {
                if (!value) {
                    this.model = null;
                }
            },
        },
        pageDate_() {
            return this.pageDate && new Date(this.pageDate);
        },
    },

    methods: {
        onInput() {
            if (this.autoClose && this.$refs.popup.status === 'show') {
                this.$nextTick(() => {
                    this.$refs.popup.close();
                });
            }
        },
    },

    mounted() {
        if (this.autoOpen) {
            this.$refs.container.click();
        }
    },
};
